import React from "react";
import { Helmet } from "react-helmet";
import { useSiteMetadata } from "../hooks/useSiteMetadata";

interface Props {
  title?: string;
  description?: string;
  keywords?: string;
  pathname?: string;
  image?: string;
  children?: React.ReactNode;
  type?: string;
}
export const HeadSeo: React.FC<Props> = ({
  title,
  description,
  keywords,
  pathname,
  children,
  image,
  type,
}) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    siteUrl,
    keywords: defaultKeywords,
  } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: image || process.env.GATSBY_DEFAULT_BANNER,
    url: `${siteUrl}${pathname || ``}`,
    keywords: keywords || defaultKeywords,
    type: type || "article",
  };

  return (
    <Helmet
      htmlAttributes={{
        lang: "en-us",
      }}
    >
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>{seo.title}</title>
      <meta
        name="robots"
        content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content={seo.type} />
      <meta property="og:site_name" content="COMMUNICATION DEVICES, INC" />
      <meta name="og:url" content={seo.url} />
      <link rel="canonical" href={seo.url} />

      <meta property="og:title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta property="og:description" content={seo.description} />

      <meta name="og:card" content="summary_large_image" />
      <meta name="og:image" content={seo.image} />
      <meta
        property="og:image:alt"
        content="CommDevices Logo - Communication Devices, Inc."
      />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />

      {children}
      <script async>
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-FVTBQB6');`}
      </script>
    </Helmet>
  );
};

export default HeadSeo;
